import React from 'react';
import { ViewStyle } from 'react-native';
import Svg, { Defs, LinearGradient, Rect, Stop } from 'react-native-svg';
import { useTheme } from '../../hooks/useTheme';

interface Props {
  color?: string;
  height?: number | string;
  containerStyle?: ViewStyle | ViewStyle[];
}

const Mask: React.FC<Props> = ({ color, height = '100%', containerStyle }) => {
  const { colors } = useTheme();
  const reactId = React.useId();
  const gradientId = `mask-gradient-${reactId.replace(/:/g, '')}`;

  const stopColor = color ?? colors.elevation0;

  return (
    <Svg
      width="100%"
      height={height}
      pointerEvents="none"
      preserveAspectRatio="none"
      viewBox="0 0 1 1"
      style={containerStyle}
    >
      <Defs>
        <LinearGradient id={gradientId} x1="0" y1="0" x2="0" y2="1">
          <Stop offset="0" stopColor={stopColor} stopOpacity={1} />
          <Stop offset="1" stopColor={stopColor} stopOpacity={0} />
        </LinearGradient>
      </Defs>
      <Rect x="0" y="0" width="1" height="1" fill={`url(#${gradientId})`} />
    </Svg>
  );
};

export default Mask;
